<template>
    <div class="card text-left" id="content-start">
        <h5><span><img v-if="iconUrl !== 'no'" alt="challenge icon submission" class="challenge-icon" :src="iconUrl"/></span>{{title}}</h5>
        <div v-if="problem" class="problem-statement">
            {{problem}}
        </div>

        <div class="label" v-if="evaluations">
            Evaluation Criteria
        </div>
        <div class="every-instruction" v-for="(evaluation, index) in evaluations" :key="index">
            <span>
                <font-awesome-icon class="fa" icon="check-circle" />
                {{evaluation}}
            </span>
        </div>
        
        <div class="label">
            Submit your work (flow)
        </div>
        <div class="every-instruction" v-for="(instruction, index) in instructions" :key="index">
            <span>
                <font-awesome-icon class="fa" icon="check-circle" />
                {{instruction}}
            </span>
        </div><br>
        <Dropzone @file="submissionReceived"></Dropzone>
        <div class="label" v-if="displayRequired">
            Display Image
        </div>
        <div class="every-instruction" v-if="displayRequired">
             <span>
                <font-awesome-icon class="fa" icon="check-circle" />
                Upload a display or showcase image in the format 1600px by 900px
            </span>
        </div><br>
        <Dropzone @file="displayReceived" v-if="displayRequired"></Dropzone>
        <ProgressButton @pressed="handleSubmission"></ProgressButton>
    </div>
</template>


<script>
import Dropzone from '@/components/Dropzone.vue'
import ProgressButton from '@/components/ProgressButton.vue'
import firebase from '../services/firebase'


export default {
    name: 'SubmissionCard',
    props: {
        title: String,
        iconUrl: String,
        problem: String,
        instructions: Array,
        displayRequired: Boolean,
        evaluations: Array
    },
    data: function() {
        return {
            submissionToUpload: null,
            displayToUpload: null
        }
    },
    components: {
        Dropzone,
        ProgressButton
    },
    methods: {
        handleSubmission: function() {
            this.$emit('submission', this.submissionToUpload, this.displayToUpload);
        },
        submissionReceived: function(file) {
            console.log("file received in submission is: " + file.name);
            mixpanel.track("submission file received", {
                "user_id": firebase.auth().currentUser.uid,
                "challenge_name": this.$route.params.slug,
                "email": firebase.auth().currentUser.email
            });
            this.submissionToUpload = file;
        },
        displayReceived: function(file) {
            console.log("file received in displayPic is: " + file.name);
            mixpanel.track("display image received", {
                "user_id": firebase.auth().currentUser.uid,
                "challenge_name": this.$route.params.slug,
                "email": firebase.auth().currentUser.email
            });
            this.displayToUpload = file;
        }
    }
}
</script>


<style scoped>

    .card {
		margin-top:20px; 
		margin-bottom:20px; 
		padding-top:0px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
	}

	.card:hover {
		margin-top:20px; 
		margin-bottom:20px; 
		padding-top:0px;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(46,61,73,0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
	}

    #content-start {
        padding-right:4%;
        padding-left:4%;
        padding-top:3%;
        padding-bottom:2%;
        margin-left:0%;
        margin-right:0%;
        color:#444;
    }

    .challenge-icon {
        width:100px;
        height:54px;
        margin-right:15px;
    }

    .fa {
        color:green;
        margin-right:10px;
    }

    .problem-statement {
        margin-top:10px;
        margin-bottom:10px;
        font-size:0.9rem;
    }

    .every-instruction {
        font-size: 0.9rem;
    }

    .label {
        font-size: 1.1rem;
        margin-bottom:10px;
        margin-top:40px;
    }

</style>
